import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: ReactNode;
  requiredPermissions?: string[];
}

export const ProtectedRoute = ({ children, requiredPermissions = [] }: ProtectedRouteProps) => {
  const userStr = localStorage.getItem('user');
  const user = userStr ? JSON.parse(userStr) : null;

  if (!user?.isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Se o usuário tem permissão * (admin), permite acesso a tudo
  if (user?.permissions?.includes('*')) {
    return <>{children}</>;
  }

  // Se não há permissões requeridas, permite acesso
  if (!requiredPermissions || requiredPermissions.length === 0) {
    return <>{children}</>;
  }

  // Verifica se o usuário tem pelo menos uma das permissões requeridas
  const hasRequiredPermission = requiredPermissions.some(permission =>
    user?.permissions?.includes(permission)
  );

  if (!hasRequiredPermission) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}; 